<div class="fixed top-0 w-full h-full z-[1001] flex justify-center items-center bg-orange-50 bg-opacity-60">
  <mat-spinner></mat-spinner>
</div>
